import { FormEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSTenant, type TenantBranding } from '../../api/saas';

export function BrandingCenterPage() {
  const [tenants, setTenants] = useState<SaaSTenant[]>([]);
  const [selected, setSelected] = useState('');
  const [branding, setBranding] = useState<TenantBranding>({});
  const [error, setError] = useState('');

  useEffect(() => { void saasApi.tenants().then(setTenants).catch((e) => setError(String(e))); }, []);

  useEffect(() => {
    if (!selected) return;
    void saasApi.getBranding(selected).then(setBranding).catch((e) => setError(String(e)));
  }, [selected]);

  const onSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!selected) return;
    await saasApi.updateBranding(selected, branding);
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Branding Center</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <select className="mt-4 rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" value={selected} onChange={(e) => setSelected(e.target.value)}>
        <option value="">Select tenant</option>
        {tenants.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
      {selected && (
        <form onSubmit={onSave} className="mt-4 space-y-3 rounded-lg border p-4 dark:border-slate-700">
          <input className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" placeholder="Display name" value={branding.display_name ?? ''} onChange={(e) => setBranding({ ...branding, display_name: e.target.value })} />
          <input className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" placeholder="Primary color" value={branding.primary_color ?? ''} onChange={(e) => setBranding({ ...branding, primary_color: e.target.value })} />
          <input className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" placeholder="Logo URL" value={branding.logo_url ?? ''} onChange={(e) => setBranding({ ...branding, logo_url: e.target.value })} />
          <select className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" value={branding.theme ?? 'light'} onChange={(e) => setBranding({ ...branding, theme: e.target.value })}>
            <option value="light">Light Theme</option>
            <option value="dark">Dark Theme</option>
          </select>
          <button type="submit" className="rounded bg-slate-900 px-4 py-2 text-sm text-white dark:bg-slate-100 dark:text-slate-900">Save Branding</button>
        </form>
      )}
    </div>
  );
}
